let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9jfSP")).then(() => parcelRequire('bX0fK'));